import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetUserAssets } from '../../services';

const initialState = {
    userAssets: [],
    selectedAsset: null,
    loading: false,
    loaded: false,
    loadedForUserId: null,
    error: null,
};

export const fetchUserAssets = createAsyncThunk(
    'userAssets/fetchUserAssets',
    async (userId) => {
        const response = await GetUserAssets(userId);
        return response.data;
    }
);

const userAssetsSlice = createSlice({
    name: 'userAssets',
    initialState,
    reducers: {
        setSelectedAsset: (state, action) => {
            state.selectedAsset = action.payload;
        },
        clearUserAssets: () => initialState,
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserAssets.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserAssets.fulfilled, (state, action) => {
                state.loading = false;
                state.loaded = true;
                state.loadedForUserId = action.meta.arg;
                state.userAssets = action.payload;
            })
            .addCase(fetchUserAssets.rejected, (state, action) => {
                state.loading = false;
                state.loaded = true;
                state.error = action.error.message || 'Failed to load user assets';
            });
    },
});

export const { userAssets, loading, setSelectedAsset, clearUserAssets } = userAssetsSlice.actions;

export default userAssetsSlice.reducer;
